import ProtectedImage from './ProtectedImage';

export default ProtectedImage;
